import { Pipe, PipeTransform } from '@angular/core';
import { Duration } from 'luxon';

// Converts Luxon duration into h:mm format and handles negative values correctly.
@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(value: Duration | undefined): string {
    if (!value) {
      return '';
    }

    if (value.as('minutes') < 0) {
      return `-${value.negate().toFormat('h:mm')}`;
    }
    return value.toFormat('h:mm');
  }
}
